var map = {
  "./cs.json": [
    "f6",
    [
      "9t"
    ]
  ],
  "./en.json": [
    "XoZ",
    [
      "9i"
    ]
  ],
  "./pl.json": [
    "H9",
    [
      "lu"
    ]
  ],
  "./ru.json": [
    "tUh",
    [
      "n77"
    ]
  ],
  "./tr.json": [
    "hob",
    [
      "no"
    ]
  ],
  "./ja.json": [
    "Bh",
    [
      7
    ]
  ],
  "./zh.json": [
    "Abj",
    [
      "qz"
    ]
  ],
  "./pt-br.json": [
    "gz",
    [
      "a8l"
    ]
  ],
  "./de.json": [
    "ma",
    [
      466
    ]
  ],
  "./es.json": [
    "L3",
    [
      "ha7"
    ]
  ],
  "./fr.json": [
    "Cc",
    [
      "wx"
    ]
  ],
  "./it.json": [
    "zi",
    [
      "dxr"
    ]
  ],
  "./ko.json": [
    "Aid",
    [
      "q6"
    ]
  ],
  "./pt.json": [
    "PDj",
    [
      "1x"
    ]
  ]
};
function __rspack_async_context(req) {
  if(!__webpack_require__.o(map, req)) {
    return Promise.resolve().then(() => {
var e = new Error("Cannot find module '" + req + "'");
e.code = 'MODULE_NOT_FOUND';
throw e;
});
  }

  var ids = map[req], id = ids[0];
  return __webpack_require__.e(ids[1][0]).then(() => (__webpack_require__.t(id, 3 | 16)));
}

__rspack_async_context.keys = () => (Object.keys(map));
__rspack_async_context.id = "x0";
module.exports = __rspack_async_context;
